import actionCreatorFactory from "typescript-fsa";
import { CommonAsyncType } from "../../core/types";
import { DashboardRequestBody, DashboardResponse } from "../../core/api/requests/dashboard/types";

const actionCreator = actionCreatorFactory("@@Dashboard");

export const dashboardActions = {
    fetchDashboardData: actionCreator.async<CommonAsyncType<DashboardResponse> & DashboardRequestBody, DashboardResponse>("FETCH_DASHBOARD_DATA"),
    resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
}